export default __webpack_public_path__ + "static/media/chooseLangModalBC3.d9a45ec6.png";